import React from 'react';
import {
    Calendar,
    TrendingUp,
    Users,
    BrainCircuit,
    UserCog,
    Trophy,
    Activity,
    Calculator
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BottomNav = ({
    role,
    activeTab,
    onNavigate,
    isProfileComplete
}) => {
    const { t } = useTranslation();

    const navItems = [
        {
            id: 'home',
            label: role === 'trainer' ? t('sidebar.trainer') : t('sidebar.routines'),
            icon: role === 'trainer' ? Users : Calendar,
            disabled: !isProfileComplete
        },
        {
            id: 'analytics',
            label: t('sidebar.analytics'),
            icon: TrendingUp,
            disabled: !isProfileComplete
        },
        {
            id: 'tools',
            label: t('sidebar.tools'),
            icon: Calculator,
            disabled: false,
            elementId: 'nav-tools'
        },
        {
            id: 'feed',
            label: t('social.feed_tab'),
            icon: Activity,
            disabled: !isProfileComplete,
            elementId: 'nav-feed'
        },
        {
            id: 'ranking',
            label: t('social.ranking_tab'),
            icon: Trophy,
            disabled: !isProfileComplete
        },
        {
            id: 'friends',
            label: t('sidebar.friends'),
            icon: Users,
            disabled: !isProfileComplete
        },
        {
            id: 'coach',
            label: t('sidebar.coach'),
            icon: BrainCircuit,
            disabled: !isProfileComplete
        },
        {
            id: 'profile',
            label: t('sidebar.profile'),
            icon: UserCog,
            disabled: false
        }
    ];

    return (
        <nav style={{ bottom: 0 }} className="md:hidden fixed left-0 right-0 bg-black/95 backdrop-blur-xl border-t border-neutral-900 z-[100] pb-safe">
            <div className="flex items-center px-2 py-2 overflow-x-auto scrollbar-hide gap-1">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = activeTab === item.id;

                    return (
                        <button
                            key={item.id}
                            id={item.elementId}
                            onClick={() => !item.disabled && onNavigate(item.id)}
                            disabled={item.disabled}
                            className={`flex flex-col items-center gap-1 p-2 min-w-[60px] flex-shrink-0 transition-all duration-200
                ${isActive ? 'text-red-600' : 'text-neutral-500 hover:text-neutral-300'}
                ${item.disabled ? 'opacity-30 cursor-not-allowed' : 'active:scale-95 hover:scale-105'}
              `}
                        >
                            <div className={`p-1.5 rounded-xl transition-all duration-200 ${isActive ? 'bg-red-600/10' : 'bg-transparent'}`}>
                                <Icon
                                    size={20}
                                    strokeWidth={isActive ? 2.5 : 2}
                                    className={isActive ? 'animate-pulse-once' : ''}
                                />
                            </div>
                            <span className="text-[9px] font-black uppercase tracking-wider">
                                {item.label}
                            </span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
};

export default BottomNav;
